<template>
  <div id="videoList" align="center" v-loading="loading" style="min-height: 200px;">
    <div v-for="(class_value, class_key) in classes">
      <div class="video_list">
        <el-divider content-position="left">{{class_value.class_name}}</el-divider>
        <div class="video_item" v-for="(course_value, course_key) in class_value.video_courses"
             @click="videoDetailHandler(course_value.tid, class_value.tid)">
          <el-image class="course_cover_image" fit="cover" :src="course_value.cover_image_url"></el-image>
          <div class="course_cover_title">{{course_value.name}}</div>
          <div class="course_cover_detail">
            <template v-if="course_value.study_video_count === 0">
              <span>未开始学习，共{{course_value.video_count}}个视频</span>
            </template>
            <template v-else-if="course_value.study_video_count < course_value.video_count">
              <span>已学习{{course_value.study_video_count}}个视频，共{{course_value.video_count}}个视频</span>
            </template>
            <template v-else>
              <span style="color:#23c4a2">已完成，共{{course_value.video_count}}个视频</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {APIRequest} from '@/api/api';

  export default {
    data() {
      return {
        loading: true,
        classes: []
      };
    },
    created() {
      this.fetchList();
    },
    methods: {
      fetchList() {
        let self = this;
        let params = {};
        self.loading = true;
        APIRequest('getVideoLog', params, true).then(res => {
          console.log(res);
          self.loading = false;
          self.classes = res.data;
        }, err => {
          self.loading = false;
        });
      },
      videoDetailHandler(tid, class_tid) {
        this.$router.replace('/course_detail?tid=' + tid + '&class_tid=' + class_tid);
      }
    },
  }
</script>

<style>
  .video_list {
    position: relative;
    text-align: left;
    min-width: 1040px;
    max-width: 1300px;
    margin: 20px 200px 20px 200px;
    padding: 0;
  }

  .video_list .video_item {
    position: relative;
    width: 240px;
    padding: 0 12px 16px 0;
    margin: 10px 10px 20px 10px;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    cursor: pointer;
  }

  .video_list .video_item .course_cover_image {
    width: 240px;
    height: 180px;
    display: block;
  }

  .video_list .video_item .course_cover_title {
    width: 240px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    display: block;
    overflow: hidden;
  }

  .video_list .video_item .course_cover_detail {
    width: 250px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    display: block;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoCourse/MyCourse.vue